 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-075daa12":"9f4ee715","chunk-19a41732":"dc16f164","chunk-4113a475":"55b35146","chunk-1760e982":"4606c4ff","chunk-4c2c289d":"d569eaff","chunk-6f7049cf":"bc15f79a","chunk-1a099587":"da10d787","chunk-1aa7a1a4":"eb9b0611","chunk-1c2e00d2":"991443c2","chunk-2559aba4":"dd6cc8ba","chunk-2d0e1d50":"217eb6c9","chunk-7ccaf2c5":"dab131de","chunk-678bd322":"802cb559","chunk-21252ee5":"abbf94ca","chunk-2d217e2b":"ce420c06","chunk-2d225dc8":"9c3666aa","chunk-2d228ca1":"e66c59ab","chunk-2d22bcc3":"0e03816d","chunk-2d230e64":"7ef44dd4","chunk-34e4d36c":"72d8c0d0","chunk-381012b2":"d7781d98","chunk-73930a30":"273f7572","chunk-79f4e90b":"3c9f1178","chunk-5b455e8a":"8248848f","chunk-7b250e5e":"ed755ac2","chunk-099a0870":"a88abe65","chunk-0370a0d4":"261c91ab","chunk-31f56e98":"ad3d1b88","chunk-49af5115":"09df9ac0","chunk-6a259868":"1e163769","chunk-f24f2c30":"af414a0d","chunk-45389511":"456c652b","chunk-8fd193d6":"6bc36416","chunk-4b33d10c":"1664498e","chunk-56e638de":"45a87cf9","chunk-63d07c90":"8d1856a5","chunk-a031edac":"f3d8d0b6","chunk-a16245b6":"68a66430","chunk-a4539b76":"d8ccd2a9","chunk-c3697618":"f638200e","chunk-d6946bdc":"1af2c480","chunk-f8e87394":"539d1d8d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-075daa12":1,"chunk-1760e982":1,"chunk-4c2c289d":1,"chunk-6f7049cf":1,"chunk-1a099587":1,"chunk-1aa7a1a4":1,"chunk-2559aba4":1,"chunk-21252ee5":1,"chunk-34e4d36c":1,"chunk-381012b2":1,"chunk-73930a30":1,"chunk-79f4e90b":1,"chunk-5b455e8a":1,"chunk-099a0870":1,"chunk-0370a0d4":1,"chunk-31f56e98":1,"chunk-49af5115":1,"chunk-6a259868":1,"chunk-f24f2c30":1,"chunk-45389511":1,"chunk-8fd193d6":1,"chunk-4b33d10c":1,"chunk-56e638de":1,"chunk-63d07c90":1,"chunk-a031edac":1,"chunk-a4539b76":1,"chunk-c3697618":1,"chunk-d6946bdc":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-075daa12":"fd79da1b","chunk-19a41732":"31d6cfe0","chunk-4113a475":"31d6cfe0","chunk-1760e982":"ddc70ca9","chunk-4c2c289d":"a62d98fb","chunk-6f7049cf":"81e172f0","chunk-1a099587":"52366562","chunk-1aa7a1a4":"73c45fdd","chunk-1c2e00d2":"31d6cfe0","chunk-2559aba4":"7b75d8d0","chunk-2d0e1d50":"31d6cfe0","chunk-7ccaf2c5":"31d6cfe0","chunk-678bd322":"31d6cfe0","chunk-21252ee5":"15d8ded1","chunk-2d217e2b":"31d6cfe0","chunk-2d225dc8":"31d6cfe0","chunk-2d228ca1":"31d6cfe0","chunk-2d22bcc3":"31d6cfe0","chunk-2d230e64":"31d6cfe0","chunk-34e4d36c":"fd79da1b","chunk-381012b2":"54453b75","chunk-73930a30":"d0f8922e","chunk-79f4e90b":"8e07cf5c","chunk-5b455e8a":"add0252f","chunk-7b250e5e":"31d6cfe0","chunk-099a0870":"ec08f041","chunk-0370a0d4":"9b995d24","chunk-31f56e98":"a60a1433","chunk-49af5115":"afb90023","chunk-6a259868":"b6740363","chunk-f24f2c30":"bd1fed80","chunk-45389511":"42cb0a4a","chunk-8fd193d6":"730de3ba","chunk-4b33d10c":"2ca868c9","chunk-56e638de":"5f569bd5","chunk-63d07c90":"9bde72e7","chunk-a031edac":"4a2c5ea7","chunk-a16245b6":"31d6cfe0","chunk-a4539b76":"c59c16b7","chunk-c3697618":"1bc5fb62","chunk-d6946bdc":"8db12e39","chunk-f8e87394":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_vuexy-vuejs-react-html-laravel-admin-dashboard-template"] = window["webpackJsonp_vuexy-vuejs-react-html-laravel-admin-dashboard-template"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
